import type { AppStateController } from '../../app/state/AppStateController';

export interface GameSceneMetrics {
  revivesUsed: number;
}

export function createGameSceneMetrics(stateController: AppStateController): GameSceneMetrics {
  return {
    revivesUsed: stateController.getLevelReviveUsedCount(),
  };
}
